// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import vUploader from 'v-uploader'
import { store } from './store/store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faSpinner)

Vue.component('font-awesome-icon', FontAwesomeIcon)

axios.defaults.baseURL = `${process.env.ROOT_API}/api`
axios.defaults.withCredentials = true
axios.defaults.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`

Vue.config.productionTip = false

export const bus = new Vue()

const uploaderConfig = {
  uploadFileUrl: `${process.env.ROOT_API}/api/files/upload`,
  deleteFileUrl: `${process.env.ROOT_API}/api/files/delete`,
  language: 'en',
  fileTypeExts: 'png,jpeg,jpg,pdf',
  showMessage: (uploader, message, files) => {
    bus.$emit('uploadError', message)
  }
}

Vue.use(vUploader, uploaderConfig);


/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js